// import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { Box } from "@mui/material";
// import {
//   X,
//   User,
//   Phone,
//   Mail,
//   Home,
//   Briefcase,
//   MapPin,
//   Flag,
//   Building2,
//   Map,
// } from "lucide-react";
// import { useAppDispatch } from "../../../Redux Toolkit/Store";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { Address } from "../../../types/userTypes";

// const ContactSchema = Yup.object().shape({
//   name: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "Name should contain only letters")
//     .min(3, "Name must be at least 3 characters")
//     .required("Name is required"),

//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, "Mobile number must be exactly 10 digits")
//     .required("Mobile number is required"),

//   email: Yup.string().email("Invalid email address"),

//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
//     .required("Pincode is required"),

//   address: Yup.string()
//     .trim()
//     .min(5, "Address must be at least 5 characters")
//     .required("Address is required"),

//   locality: Yup.string()
//     .trim()
//     .min(3, "Locality must be at least 3 characters")
//     .required("Locality is required"),

//   city: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "City should contain only letters")
//     .required("City is required"),

//   state: Yup.string()
//     .trim()
//     .matches(/^[A-Za-z ]+$/, "State should contain only letters")
//     .required("State is required"),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway?: string;
//   mode?: "checkout" | "profile";
//   onAddressSubmit?: (address: Address) => void;
//   initialAddress?: Address | null;
// }

// const inputBase =
//   "w-full h-[46px] rounded-xl border border-gray-300 bg-white disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed px-3 pl-10 text-sm outline-none transition focus:border-primary-color focus:ring-1 focus:ring-primary-color";

// const labelBase =
//   "absolute -top-2 left-3 z-10 bg-white px-1.5 text-[11px] font-medium text-gray-700";

// const FieldWrapper = ({
//   label,
//   icon,
//   children,
// }: {
//   label: string;
//   icon: React.ReactNode;
//   children: React.ReactNode;
// }) => (
//   <div className="relative">
//     <label className={labelBase}>{label}</label>

//     <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600">
//       {icon}
//     </div>

//     {children}
//   </div>
// );

// const AddressForm: React.FC<AddressFormProp> = ({
//   handleClose,
//   paymentGateway = "",
//   mode = "checkout",
//   onAddressSubmit,
//   initialAddress,
// }) => {
//   const dispatch = useAppDispatch();

//   const [autoFilled, setAutoFilled] = useState(false);

//   const [addressType, setAddressType] = useState<"home" | "work">("home");

//   const [isDefault, setIsDefault] = useState(false);

//   useEffect(() => {
//     const type = initialAddress?.addressType?.trim().toLowerCase();

//     if (type === "work" || type === "office") {
//       setAddressType("work");
//     } else {
//       setAddressType("home");
//     }

//     setIsDefault(Boolean(initialAddress?.defaultAddress));
//   }, [initialAddress]);

//   const handleCreateOrder = (address: Address) => {
//     dispatch(
//       createOrder({
//         address,
//         jwt: localStorage.getItem("jwt") || "",
//         paymentGateway,
//       })
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: initialAddress?.name || "",
//       mobile: initialAddress?.mobile || "",
//       email: initialAddress?.email || "",
//       address: initialAddress?.address || "",
//       locality: initialAddress?.locality || "",
//       landmark: initialAddress?.landmark || "",
//       pinCode: initialAddress?.pinCode || "",
//       city: initialAddress?.city || "",
//       state: initialAddress?.state || "",
//     },

//     enableReinitialize: true,

//     validationSchema: ContactSchema,

//     onSubmit: (values) => {
//       const address = {
//         ...initialAddress,
//         name: values.name.trim(),
//         mobile: values.mobile.trim(),
//         email: values.email.trim(),
//         addressType: addressType === "home" ? "Home" : "Work",
//         pinCode: values.pinCode.trim(),
//         address: values.address.trim(),
//         locality: values.locality.trim(),
//         landmark: values.landmark.trim(),
//         city: values.city.trim(),
//         state: values.state.trim(),
//         defaultAddress: isDefault,
//       } as Address;

//       if (onAddressSubmit) {
//         onAddressSubmit(address);
//         return;
//       }

//       if (mode === "checkout") {
//         handleCreateOrder(address);
//         handleClose();
//       }
//     },
//   });

//   useEffect(() => {
//     const fetchLocation = async () => {
//       const pinCode = formik.values.pinCode.trim();

//       if (!/^\d{6}$/.test(pinCode)) {
//         setAutoFilled(false);
//         return;
//       }

//       if (initialAddress && pinCode === initialAddress.pinCode) {
//         setAutoFilled(false);
//         return;
//       }

//       try {
//         const res = await fetch(
//           `https://api.postalpincode.in/pincode/${pinCode}`
//         );

//         const data = await res.json();
//         const postOffice = data?.[0]?.PostOffice?.[0];

//         if (data?.[0]?.Status === "Success" && postOffice) {
//           formik.setFieldValue("city", postOffice.District || "");
//           formik.setFieldValue("state", postOffice.State || "");
//           setAutoFilled(true);
//         } else {
//           formik.setFieldValue("city", "");
//           formik.setFieldValue("state", "");
//           setAutoFilled(false);
//         }
//       } catch (error) {
//         console.error("Error fetching city/state:", error);
//         setAutoFilled(false);
//       }
//     };

//     fetchLocation();
//   }, [formik.values.pinCode, initialAddress?.pinCode]);

//   const errorText = (field: keyof typeof formik.values) =>
//     formik.touched[field] && formik.errors[field] ? (
//       <p className="mt-1 text-[10px] text-red-500">
//         {formik.errors[field]}
//       </p>
//     ) : null;

//   const handlePinCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const value = event.target.value.replace(/\D/g, "").slice(0, 6);
//     formik.setFieldValue("pinCode", value);

//     if (value.length < 6) {
//       formik.setFieldValue("city", "");
//       formik.setFieldValue("state", "");
//       setAutoFilled(false);
//     }
//   };

//   return (
//     <Box sx={{ width: "100%", outline: "none", overflow: "hidden" }}>
//       <div className="mx-auto mt-4 flex w-full max-w-[430px] flex-col overflow-hidden rounded-3xl bg-white p-4 shadow-2xl md:mt-6 md:max-w-[620px] md:p-5">
//         {/* Header */}
//         <div className="relative flex h-[58px] shrink-0 items-center justify-center border-b border-gray-200 px-4">
//           <h1 className="text-xl font-bold text-black">
//             {initialAddress ? "Update Address" : "Add New Address"}
//           </h1>

//           <button
//             type="button"
//             onClick={handleClose}
//             className="absolute right-4 text-black"
//           >
//             <X size={22} />
//           </button>
//         </div>

//         {/* Form */}
//         <form onSubmit={formik.handleSubmit} className="px-1 pb-2 pt-5">
//           <div className="grid grid-cols-2 gap-3">
//             {/* Name */}
//             <div>
//               <FieldWrapper label="Full Name *" icon={<User size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="name"
//                   placeholder="Enter full name"
//                   value={formik.values.name}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>

//               {errorText("name")}
//             </div>

//             {/* Mobile */}
//             <div>
//               <FieldWrapper label="Mobile Number *" icon={<Phone size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="mobile"
//                   placeholder="Enter mobile number"
//                   value={formik.values.mobile}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>

//               {errorText("mobile")}
//             </div>

//             {/* Email */}
//             <div className="col-span-2">
//               <FieldWrapper label="Email (Optional)" icon={<Mail size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="email"
//                   placeholder="Enter email address"
//                   value={formik.values.email}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>

//               {errorText("email")}
//             </div>

//             {/* Address Type */}
//             <div className="relative rounded-xl border border-gray-300 px-3 pb-3 pt-4">
//               <label className="absolute -top-2 left-3 bg-white px-1.5 text-[11px] font-medium text-gray-700">
//                 Address Type *
//               </label>

//               <div className="grid grid-cols-2 gap-2">
//                 {[
//                   { key: "home", label: "Home", icon: <Home size={18} /> },
//                   { key: "work", label: "Work", icon: <Briefcase size={18} /> },
//                 ].map((item) => (
//                   <button
//                     key={item.key}
//                     type="button"
//                     onClick={() => setAddressType(item.key as "home" | "work")}
//                     className="flex items-center gap-2 text-sm font-medium text-gray-800"
//                   >
//                     <span
//                       className={`flex h-5 w-5 items-center justify-center rounded-full border ${
//                         addressType === item.key
//                           ? "border-primary-color"
//                           : "border-gray-400"
//                       }`}
//                     >
//                       {addressType === item.key && (
//                         <span className="h-3 w-3 rounded-full bg-primary-color" />
//                       )}
//                     </span>

//                     {item.icon}

//                     <span>{item.label}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Pincode */}
//             <div>
//               <FieldWrapper label="Pincode *" icon={<Mail size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="pinCode"
//                   placeholder="Enter pincode"
//                   value={formik.values.pinCode}
//                   onChange={handlePinCodeChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>

//               {errorText("pinCode")}
//             </div>

//             {/* Address */}
//             <div className="col-span-2">
//               <FieldWrapper
//                 label="Flat, House No., Building Name *"
//                 icon={<Home size={18} />}
//               >
//                 <input
//                   className={inputBase}
//                   name="address"
//                   placeholder="E.g. 21, Lake View Apartment"
//                   value={formik.values.address}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>

//               {errorText("address")}
//             </div>

//             {/* Locality */}
//             <div className="col-span-2">
//               <FieldWrapper
//                 label="Area, Street, Sector, Village *"
//                 icon={<MapPin size={18} />}
//               >
//                 <input
//                   className={inputBase}
//                   name="locality"
//                   placeholder="E.g. 5th Cross, Koramangala"
//                   value={formik.values.locality}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </FieldWrapper>

//               {errorText("locality")}
//             </div>

//             {/* Landmark */}
//             <div className="col-span-2">
//               <FieldWrapper
//                 label="Landmark (Optional)"
//                 icon={<Flag size={18} />}
//               >
//                 <input
//                   className={inputBase}
//                   name="landmark"
//                   placeholder="E.g. Near Forum Mall"
//                   value={formik.values.landmark}
//                   onChange={formik.handleChange}
//                 />
//               </FieldWrapper>
//             </div>

//             {/* City */}
//             <div>
//               <FieldWrapper
//                 label="City / Town *"
//                 icon={<Building2 size={18} />}
//               >
//                 <input
//                   className={inputBase}
//                   name="city"
//                   placeholder="Select city"
//                   value={formik.values.city}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   disabled={autoFilled}
//                 />
//               </FieldWrapper>

//               {errorText("city")}
//             </div>

//             {/* State */}
//             <div>
//               <FieldWrapper label="State *" icon={<Map size={18} />}>
//                 <input
//                   className={inputBase}
//                   name="state"
//                   placeholder="Select state"
//                   value={formik.values.state}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   disabled={autoFilled}
//                 />
//               </FieldWrapper>

//               {errorText("state")}
//             </div>

//             {/* Default */}
//             <label className="col-span-2 mt-1 flex items-center gap-3 px-1 text-sm font-medium text-gray-800">
//               <input
//                 type="checkbox"
//                 checked={isDefault}
//                 onChange={() => setIsDefault(!isDefault)}
//                 className="h-4 w-4 rounded accent-primary-color"
//               />
//               Make it default
//             </label>
//           </div>

//           {/* Footer */}
//           <div className="mt-4 border-t border-gray-200 pt-4">
//             <button
//               type="submit"
//               className="mb-3 h-[48px] w-full rounded-xl bg-primary-color font-semibold text-white shadow-sm transition hover:opacity-90"
//             >
//               {initialAddress ? "Update Address" : "Save Address"}
//             </button>

//             <button
//               type="button"
//               onClick={handleClose}
//               className="h-[48px] w-full rounded-xl border border-primary-color font-semibold text-primary-color transition hover:bg-primary-color/5"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>
//     </Box>
//   );
// };

// export default AddressForm;


import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box } from "@mui/material";
import {
  X,
  User,
  Phone,
  Mail,
  Home,
  Briefcase,
  MapPin,
  Flag,
  Building2,
  Map,
} from "lucide-react";
import { useAppDispatch } from "../../../Redux Toolkit/Store";
import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
import { Address } from "../../../types/userTypes";

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .matches(/^[A-Za-z ]+$/, "Name should contain only letters")
    .min(3, "Name must be at least 3 characters")
    .required("Name is required"),

  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),

  email: Yup.string().email("Invalid email address"),

  pinCode: Yup.string()
    .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
    .required("Pincode is required"),

  address: Yup.string()
    .trim()
    .min(5, "Address must be at least 5 characters")
    .required("Address is required"),

  locality: Yup.string()
    .trim()
    .min(3, "Locality must be at least 3 characters")
    .required("Locality is required"),

  city: Yup.string()
    .trim()
    .matches(/^[A-Za-z ]+$/, "City should contain only letters")
    .required("City is required"),

  state: Yup.string()
    .trim()
    .matches(/^[A-Za-z ]+$/, "State should contain only letters")
    .required("State is required"),
});

interface AddressFormProp {
  handleClose: () => void;
  paymentGateway?: string;
  mode?: "checkout" | "profile";
  onAddressSubmit?: (address: Address) => void;
  initialAddress?: Address | null;
}

const inputBase =
  "w-full h-[46px] rounded-xl border border-gray-300 bg-white disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed px-3 pl-10 text-sm outline-none transition focus:border-primary-color focus:ring-1 focus:ring-primary-color";

const labelBase =
  "absolute -top-2 left-3 z-10 bg-white px-1.5 text-[11px] font-medium text-gray-700";

const FieldWrapper = ({
  label,
  icon,
  children,
}: {
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) => (
  <div className="relative">
    <label className={labelBase}>{label}</label>

    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600">
      {icon}
    </div>

    {children}
  </div>
);

const AddressForm: React.FC<AddressFormProp> = ({
  handleClose,
  paymentGateway = "",
  mode = "checkout",
  onAddressSubmit,
  initialAddress,
}) => {
  const dispatch = useAppDispatch();

  const [autoFilled, setAutoFilled] = useState(false);
  const [addressType, setAddressType] = useState<"home" | "work">("home");
  const [isDefault, setIsDefault] = useState(false);
  const [pinLoading, setPinLoading] = useState(false);
  const [pinLookupError, setPinLookupError] = useState("");

  useEffect(() => {
    const type = initialAddress?.addressType?.trim().toLowerCase();

    if (type === "work" || type === "office") {
      setAddressType("work");
    } else {
      setAddressType("home");
    }

    setIsDefault(Boolean(initialAddress?.defaultAddress));
  }, [initialAddress]);

  const handleCreateOrder = (address: Address) => {
    dispatch(
      createOrder({
        address,
        jwt: localStorage.getItem("jwt") || "",
        paymentGateway,
      })
    );
  };

  const formik = useFormik({
    initialValues: {
      name: initialAddress?.name || "",
      mobile: initialAddress?.mobile || "",
      email: initialAddress?.email || "",
      address: initialAddress?.address || "",
      locality: initialAddress?.locality || "",
      landmark: initialAddress?.landmark || "",
      pinCode: initialAddress?.pinCode || "",
      city: initialAddress?.city || "",
      state: initialAddress?.state || "",
    },

    enableReinitialize: true,

    validationSchema: ContactSchema,

    onSubmit: (values) => {
      const address = {
        ...initialAddress,
        name: values.name.trim(),
        mobile: values.mobile.trim(),
        email: values.email.trim(),
        addressType: addressType === "home" ? "Home" : "Work",
        pinCode: values.pinCode.trim(),
        address: values.address.trim(),
        locality: values.locality.trim(),
        landmark: values.landmark.trim(),
        city: values.city.trim(),
        state: values.state.trim(),
        defaultAddress: isDefault,
      } as Address;

      if (onAddressSubmit) {
        onAddressSubmit(address);
        return;
      }

      if (mode === "checkout") {
        handleCreateOrder(address);
        handleClose();
      }
    },
  });

  useEffect(() => {
    const pinCode = formik.values.pinCode.replace(/\D/g, "");

    if (pinCode.length === 0) {
      setPinLookupError("");
      setAutoFilled(false);
      formik.setFieldValue("city", "", false);
      formik.setFieldValue("state", "", false);
      return;
    }

    if (pinCode.length < 6) {
      setPinLookupError("");
      setAutoFilled(false);
      formik.setFieldValue("city", "", false);
      formik.setFieldValue("state", "", false);
      return;
    }

    if (pinCode.length !== 6) {
      return;
    }

    const controller = new AbortController();

    const timer = window.setTimeout(async () => {
      try {
        setPinLoading(true);
        setPinLookupError("");

        const response = await fetch(
          `https://api.postalpincode.in/pincode/${pinCode}`,
          {
            method: "GET",
            signal: controller.signal,
          }
        );

        if (!response.ok) {
          throw new Error("Postal API request failed");
        }

        const data = await response.json();

        const postOffice =
          Array.isArray(data) &&
          data.length > 0 &&
          data[0]?.Status === "Success" &&
          Array.isArray(data[0]?.PostOffice) &&
          data[0].PostOffice.length > 0
            ? data[0].PostOffice[0]
            : null;

        if (postOffice) {
          await formik.setFieldValue(
            "city",
            postOffice.District || postOffice.Block || "",
            false
          );
          await formik.setFieldValue("state", postOffice.State || "", false);

          setAutoFilled(true);
          setPinLookupError("");
        } else {
          await formik.setFieldValue("city", "", false);
          await formik.setFieldValue("state", "", false);

          setAutoFilled(false);
          setPinLookupError("No city/state found for this pincode");
        }
      } catch (error: any) {
        if (error?.name !== "AbortError") {
          console.error("Error fetching city/state:", error);

          await formik.setFieldValue("city", "", false);
          await formik.setFieldValue("state", "", false);

          setAutoFilled(false);
          setPinLookupError("Unable to fetch city/state. Please enter manually.");
        }
      } finally {
        if (!controller.signal.aborted) {
          setPinLoading(false);
        }
      }
    }, 400);

    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [formik.values.pinCode]);

  const errorText = (field: keyof typeof formik.values) =>
    formik.touched[field] && formik.errors[field] ? (
      <p className="mt-1 text-[10px] text-red-500">{formik.errors[field]}</p>
    ) : null;

  return (
    <Box sx={{ width: "100%", outline: "none", overflow: "hidden" }}>
      <div className="mx-auto mt-4 flex w-full max-w-[430px] flex-col overflow-hidden rounded-3xl bg-white p-4 shadow-2xl md:mt-6 md:max-w-[620px] md:p-5">
        <div className="relative flex h-[58px] shrink-0 items-center justify-center border-b border-gray-200 px-4">
          <h1 className="text-xl font-bold text-black">
            {initialAddress ? "Update Address" : "Add New Address"}
          </h1>

          <button
            type="button"
            onClick={handleClose}
            className="absolute right-4 text-black"
          >
            <X size={22} />
          </button>
        </div>

        <form onSubmit={formik.handleSubmit} className="px-1 pb-2 pt-5">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <FieldWrapper label="Full Name *" icon={<User size={18} />}>
                <input
                  className={inputBase}
                  name="name"
                  placeholder="Enter full name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>

              {errorText("name")}
            </div>

            <div>
              <FieldWrapper label="Mobile Number *" icon={<Phone size={18} />}>
                <input
                  className={inputBase}
                  name="mobile"
                  placeholder="Enter mobile number"
                  value={formik.values.mobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    formik.setFieldValue("mobile", value);
                  }}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>

              {errorText("mobile")}
            </div>

            <div className="col-span-2">
              <FieldWrapper label="Email (Optional)" icon={<Mail size={18} />}>
                <input
                  className={inputBase}
                  name="email"
                  placeholder="Enter email address"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>

              {errorText("email")}
            </div>

            <div className="relative rounded-xl border border-gray-300 px-3 pb-3 pt-4">
              <label className="absolute -top-2 left-3 bg-white px-1.5 text-[11px] font-medium text-gray-700">
                Address Type *
              </label>

              <div className="grid grid-cols-2 gap-2">
                {[
                  { key: "home", label: "Home", icon: <Home size={18} /> },
                  { key: "work", label: "Work", icon: <Briefcase size={18} /> },
                ].map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    onClick={() => setAddressType(item.key as "home" | "work")}
                    className="flex items-center gap-2 text-sm font-medium text-gray-800"
                  >
                    <span
                      className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                        addressType === item.key
                          ? "border-primary-color"
                          : "border-gray-400"
                      }`}
                    >
                      {addressType === item.key && (
                        <span className="h-3 w-3 rounded-full bg-primary-color" />
                      )}
                    </span>

                    {item.icon}

                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <div>
              <FieldWrapper label="Pincode *" icon={<MapPin size={18} />}>
                <input
                  className={inputBase}
                  name="pinCode"
                  placeholder="Enter pincode"
                  value={formik.values.pinCode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    formik.setFieldValue("pinCode", value, false);

                    if (value.length < 6) {
                      formik.setFieldValue("city", "", false);
                      formik.setFieldValue("state", "", false);
                      setAutoFilled(false);
                      setPinLookupError("");
                    }
                  }}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>

              {pinLoading && (
                <p className="mt-1 text-[10px] text-gray-500">
                  Fetching city and state...
                </p>
              )}

              {pinLookupError && (
                <p className="mt-1 text-[10px] text-red-500">
                  {pinLookupError}
                </p>
              )}

              {errorText("pinCode")}
            </div>

            <div className="col-span-2">
              <FieldWrapper
                label="Flat, House No., Building Name *"
                icon={<Home size={18} />}
              >
                <input
                  className={inputBase}
                  name="address"
                  placeholder="E.g. 21, Lake View Apartment"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>

              {errorText("address")}
            </div>

            <div className="col-span-2">
              <FieldWrapper
                label="Area, Street, Sector, Village *"
                icon={<MapPin size={18} />}
              >
                <input
                  className={inputBase}
                  name="locality"
                  placeholder="E.g. 5th Cross, Koramangala"
                  value={formik.values.locality}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </FieldWrapper>

              {errorText("locality")}
            </div>

            <div className="col-span-2">
              <FieldWrapper label="Landmark (Optional)" icon={<Flag size={18} />}>
                <input
                  className={inputBase}
                  name="landmark"
                  placeholder="E.g. Near Forum Mall"
                  value={formik.values.landmark}
                  onChange={formik.handleChange}
                />
              </FieldWrapper>
            </div>

            <div>
              <FieldWrapper
                label="City / Town *"
                icon={<Building2 size={18} />}
              >
                <input
                  className={inputBase}
                  name="city"
                  placeholder="City"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={autoFilled}
                />
              </FieldWrapper>

              {errorText("city")}
            </div>

            <div>
              <FieldWrapper label="State *" icon={<Map size={18} />}>
                <input
                  className={inputBase}
                  name="state"
                  placeholder="State"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={autoFilled}
                />
              </FieldWrapper>

              {errorText("state")}
            </div>

            <label className="col-span-2 mt-1 flex items-center gap-3 px-1 text-sm font-medium text-gray-800">
              <input
                type="checkbox"
                checked={isDefault}
                onChange={() => setIsDefault(!isDefault)}
                className="h-4 w-4 rounded accent-primary-color"
              />
              Make it default
            </label>
          </div>

          <div className="mt-4 border-t border-gray-200 pt-4">
            <button
              type="submit"
              className="mb-3 h-[48px] w-full rounded-xl bg-primary-color font-semibold text-white shadow-sm transition hover:opacity-90"
            >
              {initialAddress ? "Update Address" : "Save Address"}
            </button>

            <button
              type="button"
              onClick={handleClose}
              className="h-[48px] w-full rounded-xl border border-primary-color font-semibold text-primary-color transition hover:bg-primary-color/5"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Box>
  );
};

export default AddressForm;